@if (title()) {
  <a
    effy-button
    [size]="EffyButtonSize.MEDIUM"
    [color]="buttonStyle()"
    [href]="url() || ''"
    [rel]="ctaLink()?.options?.attributes?.rel || ''"
    [target]="ctaLink()?.options?.attributes?.target || ''"
    class="w-full smd:w-fit"
  >
    <span class="whitespace-nowrap" [innerHTML]="title()"></span>
  </a>
}
